import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const getUsers = createAsyncThunk(
  'users/getUsers',
  catchAsync(async (data, thunkAPI) => {
    const params = data?.new ? `?new=${true}` : '';
    const res = await axios.get(`/users${params}`);
    return res.data;
  })
);
